<template>
    <div class="home">
        <section class="account">
            <h2 class="home-title">资产统计</h2>
            <ul class="account-list">
                <li>
                    <div class="label-name">资产空间</div>
                    <div class="label-value"> {{ (accountInfo.assetSpace / 1024 / 1024 / 1024).toFixed(2) }} <span
                            class="unit">GB</span></div>

                </li>
                <li>
                    <div class="label-name">资产数量</div>
                    <div class="label-value"> {{ accountInfo.assetNum }} <span class="unit">个</span></div>

                </li>
                <li>
                    <div class="label-name">本周上传</div>
                    <div class="label-value"> {{ accountInfo.weekUploadNum }} <span class="unit">个</span></div>

                </li>
                <li>
                    <div class="label-name">模型数量</div>
                    <div class="label-value"> {{ accountInfo.modelNum }} <span class="unit">个</span></div>

                </li>
                <li>
                    <div class="label-name">作品数量</div>
                    <div class="label-value"> {{ accountInfo.workNum }} <span class="unit">个</span></div>

                </li>
                <li>
                    <div class="label-name">版权登记</div>
                    <div class="label-value"> 0 <span class="unit">个</span></div>

                </li>
                <li>
                    <div class="label-name">发布数量</div>
                    <div class="label-value"> {{ accountInfo.releaseNum }} <span class="unit">个</span></div>

                </li>
                <li>
                    <div class="label-name">下载数量</div>
                    <div class="label-value"> {{ accountInfo.downloadNum }} <span class="unit">个</span></div>

                </li>
                <li>
                    <div class="label-name">购买数量</div>
                    <div class="label-value"> {{ accountInfo.purchaseNum }} <span class="unit">个</span></div>

                </li>
                <li>
                    <div class="label-name">收藏数量</div>
                    <div class="label-value"> 0 <span class="unit">个</span></div>

                </li>
                <li>
                    <div class="label-name">关注用户</div>
                    <div class="label-value"> {{ accountInfo.followCount }} <span class="unit">个</span></div>

                </li>
                <li>
                    <div class="label-name">粉丝数量</div>
                    <div class="label-value"> {{ accountInfo.fansCount }} <span class="unit">个</span></div>

                </li>
            </ul>
        </section>

        <div class="middle">
            <section>
                <h2 class="home-title">资产上传</h2>
                <div style=" height: 236rem;" ref="chart_1"></div>
            </section>
            <section>
                <h2 class="home-title">资产格式</h2>
                <div style="height: 236rem;" ref="chart_2"></div>
            </section>
            <section>
                <h2 class="home-title">资产大小</h2>
                <div style="height: 236rem;" ref="chart_3"></div>
            </section>
        </div>

        <section class="bottom">
            <h2 class="home-title">资产分类</h2>
            <div style="height: 242rem;" ref="chart_4"></div>
        </section>
        <section class="bottom">
            <h2 class="home-title">资源下载统计</h2>
            <div style="height: 242rem;" ref="chart_5"></div>
        </section>
    </div>

</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import * as echarts from 'echarts';
import { http } from '@/request/http'

const accountInfo = reactive({
    "assetSpace": 0,
    "assetNum": 0,
    "modelNum": 0,
    "workNum": 0,
    "purchaseNum": 0,
    "releaseNum": 0,
    "downloadNum": 0,
    "weekUploadNum": 0,
    "followCount": 0,
    "fansCount": 0
})

const chart_1 = ref(null)
const chart_2 = ref(null)
const chart_3 = ref(null)
const chart_4 = ref(null)
const chart_5 = ref(null)
// 资产上传
function initChart1() {
    http.get('/app-api/model/asset-day-count/getByUser').then(res => {
        // 初始化图表实例
        var chart = echarts.init(chart_1.value);

        // 处理x轴日期数据（取近10天）
        const xAxisData = res.countDates.map(item => item.slice(5)).slice(0, 10);

        // 设置图表配置项
        chart.setOption({
            grid: {
                Left: '20rem',
                right: '0',
                top: '30rem',
                bottom: '40rem'
            },
            // 图例：区分两条折线
            legend: {
                data: ['模型数量', '作品数量'],
                right: '50rem',
                top: 0,
                textStyle: {
                    fontSize: 12
                },
                icon: 'circle',
                itemWidth: 8,
                itemHeight: 8,
                textStyle: {
                    color: 'rgba(139, 139, 139, 1)'
                }
            },
            xAxis: {
                type: 'category',
                data: xAxisData,
                axisLabel: {
                    interval: 0,
                    rotate: 30
                }
            },
            yAxis: {
                type: 'value',
                // name: '数量',
                // nameTextStyle: {
                //     padding: [0, 0, 0, 10]
                // }
            },
            series: [
                // 第一个系列：模型数量
                {
                    name: '模型数量',              // 与图例对应
                    data: res.modelNums.slice(0, 10),  // 模型数量数据
                    type: 'line',
                    smooth: true,
                    areaStyle: {
                        opacity: 0.8,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(87, 194, 242, 0.2)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(87, 194, 242, 0)'
                            }
                        ])
                    },
                    symbol: 'circle',             // 数据点样式
                    symbolSize: 6,                // 数据点大小
                    label: {
                        show: true,               // 显示数据标签
                        position: 'top',          // 标签位置
                        fontSize: 10,
                        formatter: (params) => {
                            return params.value === 0 ? '' : params.value;
                        }
                    },
                    lineStyle: {
                        width: 2                  // 线宽
                    },
                    itemStyle: {
                        color: 'rgba(87, 194, 242, 1)'          // 线条和点的颜色
                    }
                },
                // 第二个系列：作品数量
                {
                    name: '作品数量',              // 与图例对应
                    data: res.workNums.slice(0, 10),   // 作品数量数据
                    type: 'line',
                    smooth: true,
                    areaStyle: {
                        opacity: 0.8,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(176, 174, 243, 0.2)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(176, 174, 243, 0)'
                            }
                        ])
                    },
                    symbol: 'diamond',            // 数据点样式（与第一个系列区分）
                    symbolSize: 6,
                    label: {
                        show: true,
                        position: 'top',       // 标签位置（与第一个系列区分）
                        fontSize: 10,
                        formatter: (params) => {
                            return params.value === 0 ? '' : params.value;
                        }
                    },
                    lineStyle: {
                        width: 2,
                        type: 'dashed'            // 虚线样式（与第一个系列区分）
                    },
                    itemStyle: {
                        color: 'rgba(176, 174, 243, 1)'          // 不同的颜色
                    }
                }
            ]
        });

        // 监听窗口大小变化，自动调整图表尺寸
        window.addEventListener('resize', () => {
            chart.resize();
        });
    });
}
// 资产格式
function initChart2() {
    http.get('/app-api/model/asset-count/format').then(res => {
        var chart = echarts.init(chart_2.value)
        chart.setOption({

            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'vertical',
                left: '70%',
                top: '15%',
                itemWidth: 10,
                itemHeight: 10,
                borderRadius: 5,
                itemGap: 20,
                textStyle: {
                    color: 'rgba(139, 139, 139, 1)'
                }
            },
            series: [
                {
                    type: 'pie',
                    radius: ['40%', '70%'],
                    width: '180rem',
                    height: '180rem',
                    top: 'center',
                    right: '100rem',
                    data: res.map(item => {
                        return {
                            name: item.modelFormat,
                            value: item.modelNum
                        }
                    }),
                    label: {
                        show: false
                    }
                }
            ]
        })
    })
}
// 资产大小
function initChart3() {
    http.get('/app-api/model/asset-count/size').then(res => {
        res = res ? res.slice(0, 8) : []
        var chart = echarts.init(chart_3.value)
        chart.setOption({
            grid: {
                Left: '20rem',
                right: '0',
                top: '30rem',
                bottom: '40rem'
            },
            xAxis: {
                data: res.map(item => item.modelName.slice(0, 3))
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    data: res.map(item => Number(item.modelSize / 1024 / 1024).toFixed(2)),
                    type: 'bar',
                    barMaxWidth: 20,
                    itemStyle: {
                        /* color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 1, color: 'rgba(91, 143, 249, 0)' },
                            { offset: 0, color: 'rgba(91, 143, 249, 1)' }
                        ]) */
                        color: 'rgba(176, 174, 243, 1)',
                        borderRadius: [10, 10, 0, 0]
                    },
                    label: {
                        show: true,
                        position: 'top'
                    }
                }
            ]
        })
    })
}
// 资产分类
function initChart4() {
    http.get('/app-api/model/asset-count/cate').then(res => {
        res = res ? res.slice(0, 8) : []
        var chart = echarts.init(chart_4.value)
        chart.setOption({
            grid: {
                left: '5%',
                right: '0',
                top: '30rem',
                bottom: '40rem'
            },
            xAxis: {
                data: res.map(item => item.platformCateName.slice(0, 3))
            },
            yAxis: {
                type: 'value'
            },
            legend: {
                data: ['模型', '作品'],
                right: '5%',
                top: 0,
                icon: 'circle',
                itemWidth: 8,
                itemHeight: 8,
                textStyle: {
                    color: 'rgba(139, 139, 139, 1)'
                }
            },
            series: [
                {
                    name: '模型',
                    data: res.map(item => item.modelNum),
                    type: 'bar',
                    // stack: 'Ad',
                    barMaxWidth: '12rem',
                    itemStyle: {
                        color: 'rgba(140, 208, 245, 1)',
                        borderRadius: [5, 5, 0, 0],
                    },
                    label: {
                        show: true,
                        position: 'insideTop',
                        // 模型数量为 0 时不显示标签
                        formatter: function (params) {
                            return params.value === 0 ? '' : params.value;
                        }
                    }
                },
                {
                    name: '作品',
                    data: res.map(item => item.workNum),
                    type: 'bar',
                    // stack: 'Ad',
                    barMaxWidth: '12rem',
                    itemStyle: {
                        color: 'rgba(127, 218, 169, 1)',
                        borderRadius: [5, 5, 0, 0],
                    },
                    label: {
                        show: true,
                        position: 'insideTop',
                        // 模型数量为 0 时不显示标签
                        formatter: function (params) {
                            return params.value === 0 ? '' : params.value;
                        }
                    }
                }
            ]
        })
    })
}
// 资源下载统计
function initChart5() {
    http.get('/app-api/model/asset-day-count/getDownCountByUser').then(res => {
        /* res = {
            countDates: ['2025-12-12', '2025-12-13', '2025-12-14', '2025-12-15'],
            downNums: [20, 19, 24, 29],
            saleAmounts: [16, 12, 18, 30]
        } */
        let obj = {
            countDates: Array.isArray(res.countDates) ? res.countDates.slice(0, 8) : [],
            downNums: Array.isArray(res.downNums) ? res.downNums.slice(0, 8) : [],
            saleAmounts: Array.isArray(res.saleAmounts) ? res.saleAmounts.slice(0, 8) : [],
        }
        var chart = echarts.init(chart_5.value)
        chart.setOption({
            grid: {
                left: '5%',
                right: '5%',
                top: '30rem',
                bottom: '40rem'
            },
            xAxis: {
                data: obj.countDates
            },
            yAxis: {
                type: 'value'
            },
            legend: {
                data: ['下载数量', '销售金额'],
                right: '5%',
                top: 0,
                icon: 'circle',
                itemWidth: 8,
                itemHeight: 8,
                textStyle: {
                    color: 'rgba(139, 139, 139, 1)'
                }
            },
            series: [
                {
                    name: '下载数量',
                    data: obj.downNums,
                    type: 'line',
                    smooth: true,
                    areaStyle: {
                        opacity: 0.8,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(127, 202, 244, 0.2)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(87, 194, 242, 0)'
                            }
                        ])
                    },
                    // stack: 'Ad',
                    // barMaxWidth: '50rem',
                    itemStyle: {
                        color: 'rgba(87, 194, 242, 1)'
                    },
                    label: {
                        show: true,
                        position: 'insideTop',
                        // 模型数量为 0 时不显示标签
                        formatter: function (params) {
                            return params.value === 0 ? '' : params.value;
                        }
                    }
                },
                {
                    name: '销售金额',
                    data: obj.saleAmounts,
                    type: 'line',
                    smooth: true,
                    areaStyle: {
                        opacity: 0.8,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(250, 184, 86, 0.2)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(250, 184, 86, 0)'
                            }
                        ])
                    },
                    // stack: 'Ad',
                    // barMaxWidth: '50rem',
                    itemStyle: {
                        color: 'rgba(250, 184, 86, 1)'
                    },
                    label: {
                        show: true,
                        position: 'insideTop',
                        // 模型数量为 0 时不显示标签
                        formatter: function (params) {
                            return params.value === 0 ? '' : params.value;
                        }
                    }
                }
            ]
        })
    })
}

onMounted(() => {
    initChart1()
    initChart2()
    initChart3()
    initChart4()
    initChart5()
    http.get('/app-api/model/asset-count/getByUser').then(res => {
        Object.assign(accountInfo, res)
    })
})

</script>

<style lang="scss" scoped>
.home {
    width: 100%;
    height: 100%;
    padding: 15rem;
    background-color: #F7F7F9;

    &-title {
        font-size: 16rem;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        display: flex;
        align-items: center;
        padding: 10rem 0;

        &::before {
            content: '';
            width: 4rem;
            height: 16rem;
            border-radius: 36rem;
            background: #000;
            margin-right: 8rem;
        }
    }

    .account {
        background-color: #fff;
        padding: 10rem;

        &-list {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 10rem;
            padding: 10rem 5rem;
            li {
                // max-width: 280rem;
                // min-width: 120rem;
                width: 115rem;
                height: 54rem;
                background: linear-gradient(180deg, rgba(35, 137, 245, 0.15) 0%, rgba(35, 137, 245, 0.05) 100%);
                border-radius: 5rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 5rem 0;

                div {
                    text-align: center;
                }

                .label {
                    &-value {
                        font-size: 18rem;
                        font-weight: 500;
                        color: #000;

                        .unit {
                            font-size: 14rem;
                            font-weight: 400;
                            color: rgba(51, 51, 51, 1);
                        }
                    }

                    &-name {
                        font-size: 12rem;
                        font-weight: 400;
                        color: #808080;
                    }
                }
            }
        }
    }

    section {
        margin: 10rem 0;
        background-color: #fff;
        width: 100%;
        padding: 15rem;

        div {
            width: 100%;
            height: 310rem;
        }
    }

    .bottom {
        padding: 15rem;
        background-color: #fff;
        border-radius: 5rem;

        .home-title {
            padding: 10rem 0 0 20rem;
        }
    }
}
</style>